export const mockData = {
  about: {
    intro: "En Ladoculto, el tiempo se detiene. Somos un espacio donde la gastronomía, la música, los libros y los vinos se encuentran para crear experiencias que invitan a quedarse.",
    experience: "Cada detalle ha sido pensado para que te sientas cómodo, para que converses sin apuro, para que disfrutes de sabores cuidados y una atmósfera que acompaña.",
    atmosphere: "Un lugar íntimo y contemporáneo en el corazón de Rosario, donde lo cultural y lo gastronómico se cruzan. Un refugio para volver, una vez y otra vez."
  },
  gastro: {
    highlights: [
      {
        title: "Gastronomía de Autor",
        description: "Platos creativos elaborados con productos de calidad. Destacamos nuestro pulpo ibérico y propuestas que fusionan tradición e innovación."
      },
      {
        title: "Coctelería & Vinos",
        description: "Tragos de autor, vinos seleccionados y vermuts para acompañar cada momento. Nuestros bartenders crean experiencias únicas en cada copa."
      },
      {
        title: "Cafetería & Panadería",
        description: "Café de especialidad, pastelería artesanal y propuestas dulces para disfrutar durante la tarde. Del clásico cortado a lattes creativos."
      }
    ]
  },
  experience: {
    description: "Un lugar para quedarse, conversar y volver.",
    features: [
      "Música cuidadosamente seleccionada",
      "Ambiente íntimo y acogedor",
      "Atención cercana y personalizada",
      "Espacio inclusivo y respetuoso",
      "Detalles que hacen la diferencia"
    ]
  },
  reviews: [
    {
      text: "La comida y los tragos riquísimos, la atención buenísima.",
      author: "Cliente verificado"
    },
    {
      text: "Excelente gastronomía, sonido y atención.",
      author: "Cliente verificado"
    },
    {
      text: "Impecable, sin dudas volvería.",
      author: "Cliente verificado"
    }
  ],
  schedule: [
    {
      days: "Martes a Jueves",
      hours: "17:30 a 00:30"
    },
    {
      days: "Viernes a Domingo y Feriados",
      hours: "17:30 a 01:30"
    }
  ],
  scheduleNote: "Consumo en el lugar · No take away · No delivery",
  location: {
    address: "Zeballos 1460, Rosario (S2000), Santa Fe, Argentina"
  }
};